"use client";

import { useState } from "react";
import { RegisterForm } from "./register-form";

export function RegisterPanel() {
  const [isOpen, setIsOpen] = useState(false);

  if (!isOpen) {
    return (
      <button className="btn btn-outline" type="button" onClick={() => setIsOpen(true)}>
        Registrieren
      </button>
    );
  }

  return (
    <div className="stack-sm">
      <div className="auth-divider" />
      <h2 className="auth-subtitle">Neu hier? Registrieren</h2>
      <RegisterForm />
    </div>
  );
}
